"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkContainer = exports.Link = exports.Header = exports.Pic = exports.Paragraph = exports.Text = exports.Chest = exports.CloseButton = exports.Wrapper = exports.Plank = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Plank = _styledComponents["default"].div.withConfig({
  displayName: "styled__Plank",
  componentId: "sc-5m8gmb-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background: linear-gradient(299.06deg, #EDEDED 2.91%, #FAFAFA 86.78%);;\n    width: 100%;\n    height: 72px;\n    min-width: 320px;\n    max-width: 860px;\n    z-index: 11;\n    position: fixed;\n    display: ", ";\n    justify-content: flex-end;\n    flex-direction: row;\n    opacity: 1;\n    transition: opacity 0 ease;\n"])), function (props) {
  return props.isOpen ? 'flex' : 'none';
});

exports.Plank = Plank;

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "styled__Wrapper",
  componentId: "sc-5m8gmb-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    flex-wrap: nowrap;\n    display: flex;\n    margin: 0 auto;\n    position: fixed;\n    width: 100%;\n"])));

exports.Wrapper = Wrapper;

var CloseButton = _styledComponents["default"].div.withConfig({
  displayName: "styled__CloseButton",
  componentId: "sc-5m8gmb-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    position: absolute;\n    left: 10px;\n    top: 21px;\n    height: 22px;\n    width: 22px;\n    z-index: 10;\n"])));

exports.CloseButton = CloseButton;

var Chest = _styledComponents["default"].div.withConfig({
  displayName: "styled__Chest",
  componentId: "sc-5m8gmb-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    & {\n        transform: rotate(45deg);\n        height: 70%;\n        width: 70%;\n        z-index: 10;\n        margin-top: 5px;\n    }\n\n    &:before,\n    &:after {\n        content: '';\n        background-color: #1A1A1A;\n        border-radius: 5px;\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        transform: translate(-50%, -50%);\n        transition: background-color 0.2s linear;\n        height: 100%;\n        width: 1px;\n        z-index: 10;\n    }\n\n    &:after {\n        height: 1px;\n        width: 100%;\n    }\n\n    &:hover:after,\n    &:hover:before {\n        background-color: #ed1c24;\n    }\n"])));

exports.Chest = Chest;

var Text = _styledComponents["default"].div.withConfig({
  displayName: "styled__Text",
  componentId: "sc-5m8gmb-4"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    display: block;\n    margin-left: 10px;\n    width: 170px;\n    max-height: 72px;\n"])));

exports.Text = Text;

var Paragraph = _styledComponents["default"].p.withConfig({
  displayName: "styled__Paragraph",
  componentId: "sc-5m8gmb-5"
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    font: normal 12px \"robotoLight\", sans-serif;\n    margin: 0;\n    font-weight: 300;\n"])));

exports.Paragraph = Paragraph;

var Pic = _styledComponents["default"].img.withConfig({
  displayName: "styled__Pic",
  componentId: "sc-5m8gmb-6"
})(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    width: 42px;\n    height: 42px;\n    margin-left: 36px;\n    margin-top: 14px;\n"])));

exports.Pic = Pic;

var Header = _styledComponents["default"].p.withConfig({
  displayName: "styled__Header",
  componentId: "sc-5m8gmb-7"
})(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    font-family: \"robotoRegular\";\n    font-style: normal;\n    font-weight: normal;\n    font-size: 16px;\n    line-height: 20px;\n    margin-top: 9px;\n    margin-bottom: 4px;\n"])));

exports.Header = Header;

var Link = _styledComponents["default"].a.withConfig({
  displayName: "styled__Link",
  componentId: "sc-5m8gmb-8"
})(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    justify-content: space-between;\n    font-family: \"robotoRegular\";\n    font-style: normal;\n    font-weight: normal;\n    font-size: 14px;\n    line-height: 18px;\n    margin-right: 16px;\n    display: flex;\n    text-align: right;\n    text-decoration-line: underline;\n    color: #007AE5;\n    z-index: +1;\n"])));

exports.Link = Link;

var LinkContainer = _styledComponents["default"].div.withConfig({
  displayName: "styled__LinkContainer",
  componentId: "sc-5m8gmb-9"
})(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    align-items: center;\n"])));

exports.LinkContainer = LinkContainer;